import { ICON_CALENDAR, ICON_CONTRACTS } from "common/constants";
import React from "react";
import { Link } from "react-router-dom";
import * as moment from "moment";

const MDAItem = ({ data, index }: { data: any; index: number }) => {
  const paymentCount = data?.payments?.length || 0;
  return (
    <div className={index === 0 ? "pb-3" : "py-3"}>
      <h5 className="mb-1">
        <Link to={`/mdas/${data?.id}`}>{`${data?.name || ""}${
          data?.acronym ? ` (${data?.acronym})` : ""
        } - ${data?.region?.name || ""}`}</Link>
      </h5>
      <p className="text-secondary mb-2">
        <span className="me-2 text-capitalize fw-semibold">
          Ministry / Department / Agency
        </span>
      </p>
      <p className="text-muted mb-2">
        ... Region: {data?.region?.name}, Number of contracts: {paymentCount}{" "}
        ...
      </p>
      <ul className="list-inline d-flex align-items-center g-3 text-muted fs-14 mb-0">
        <li className="list-inline-item">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <i className={ICON_CALENDAR}></i>
            </div>
            <div className="flex-grow-1 fs-13 ms-1">
              <span className="fw-medium">
                Last updated:{" "}
                {moment(new Date(data?.updatedAt)).format("DD MMM Y")}
              </span>
            </div>
          </div>
        </li>
        <li className="list-inline-item">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <i className={ICON_CONTRACTS}></i>
            </div>
            <div className="flex-grow-1 fs-13 ms-1">
              <span className="fw-medium">{`${paymentCount} Contract${
                paymentCount !== 1 ? "s" : ""
              }`}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default MDAItem;
